import PageHeader from '../components/PageHeader';
import PrivacyPolicy from '../components/PrivacyPolicy';
import '../styles/about.css';
const Policies = () => {
    return (
       <div className="about-page">
            <PageHeader title="Applicable Policies" />
            <div className="about-section">
                <PrivacyPolicy/>
            </div>
        </div>
    )
}
export default Policies;